export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13997.991b5229.jpg";